<template>
  <div :style="style">
    <slot></slot>
  </div>
</template>

<script>
const BASE = 8;
export default {
  name: "spacing",
  props: {
    top: {
      type: Number,
      default: 0
    },
    bottom: {
      type: Number,
      default: 0
    },
    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    },
  },
  computed: {
    style() {
      return {
        margin: `${this.top * BASE}px ${this.right * BASE}px ${this.bottom * BASE}px ${this.left * BASE}px`,
      }
    }
  }
}
</script>

<style lang="stylus" src="./style.styl"></style>
